import React from 'react';
import { Box, Typography } from '@material-ui/core';
import ProductItem from './ProductItem';
import useStyles from './styles';

export function CustomerRequestList({
  products,
  onUpdateProductAmount,
  onRemoveProduct,
}) {
  const classes = useStyles();

  const handleUpdateAmount = (amount, index) => {
    onUpdateProductAmount(amount, index);
  };

  const handleRemoveProduct = (index) => {
    onRemoveProduct(index);
  };

  return (
    <Box className={classes.container}>
      {!products.length && (
        <Box display="flex" justifyContent="center">
          <Typography>SACOLA VAZIA</Typography>
        </Box>
      )}

      {products.map((product, index) => (
        <ProductItem
          key={`${product.id}-${index}`}
          product={product}
          index={index}
          onUpdateAmount={handleUpdateAmount}
          onRemoveProduct={handleRemoveProduct}
        />
      ))}
    </Box>
  );
}
